// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* #####  Loss Flow Diagram  ##### */

.loss-flow-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  /* height: calc(100vh - 60px); */
  padding: 1rem 1.5rem;
  width: 100%;
  height: auto;
  /* overflow: auto; */
  /* height: inherit; */
}

.loss-flow-container > :first-child {
  width: 64%;
  display: flex;
  flex-direction: column;
  height: -moz-fit-content;
  height: fit-content;
  justify-content: center;
  align-items: center;


}

.loss-flow-container > :last-child {
  padding:0 1vmin;
  width: 34%;
  display: flex;
  flex-direction: column;
  align-items: center;
border: 3px solid black;
}

.animate-block-1 {
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  gap: 2rem;
  width: 860px;

}

.animate-block-1 > div {
  position: relative;
  height: 7rem;
  width: 7rem;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.animate-block-1 > div > img {
  height: 6rem;
  width: 6rem;
}

.direction-arrow {
  font-weight: 900;
  font-size: 3rem;
}

.animate-block-1 > div > span {
  text-align: center;
  font-size: 1.2rem;
}

.transformer > img {
  position: absolute;
  bottom: 0;
  height: 9rem !important;
  width: 9rem !important;
}

.transformer > span {
  position: absolute;
  bottom: 0;
}

.inverter > :nth-child(3) {
  position: absolute;
  height: 3rem;
  width: 0.5rem;
  /* bottom: -45%;
    left: 35%; */
  bottom: -3.5rem;
  left: 2.5rem;
  background-color: red;
  /* border: 2px solid red; */
  animation: blink2 0.5s infinite;
}

.inverter > :nth-child(3) > div {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 0.5rem;
  width: 15rem;
  background-color: red;
  animation: blink2 0.5s infinite;
}

.inverter > :nth-child(3) > div > div {
  position: absolute;
  top: 0;
  left: 0;
  height: 3rem;
  width: 0.5rem;
  background-color: red;
  animation: blink2 0.5s infinite;
}

.inverter > :last-child {
  position: absolute;
  height: 3rem;
  width: 0.5rem;
  /* bottom: -45%;
    right: 35%; */
  bottom: -3.5rem;
  right: 2rem;
  background-color: blue;
  /* border: 2px solid red; */
}

.inverter > :last-child > div {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 0.5rem;
  width: 10rem;
  background-color: blue;
}

.inverter > :last-child > div > div {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 3rem;
  width: 0.5rem;
  background-color: blue;
}

.inverter > :nth-child(3) > div > div > div {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 3vmin;
  position: absolute;
  top: 100%;
  right: -12rem;
  width: 24rem;
  height: 5rem;
  color: white;
  background: linear-gradient(to right, rgb(124, 208, 93),rgb(124, 208, 93));
}

.animate-block-2 {
  /* border: 2px solid red; */
  /* width: 130vh; */
  width: 860px;
  margin: 0 auto;
  padding: 0.5rem 1rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2.5rem;
  padding-right: 5rem;
}
.animate-block-2 > :first-child {
  position: absolute;
  top: -5rem;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.solar-box-1 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2.5rem;
}
.solar-box-2 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2.5rem;
}
.solar-box-1 > div,
.solar-box-2 > div {
  position: relative;
  height: 5rem;
  width: 7rem;
}
.solar-panel-1 {
  height: 100%;
  width: 100%;
  position: absolute;
  background: linear-gradient(to right, #19196c, #2b3b92, #3859ac, #4677c7);
  box-shadow: 1px 1px 2px black;
  animation: blink 1s ease-in-out infinite;
}
.solar-panel-2 {
  height: 100%;
  width: 100%;
  position: absolute;
  right: 12%;
  top: 12%;
  background: linear-gradient(to right, #19196c, #2b3b92, #3859ac, #4677c7);
  box-shadow: 1px 1px 2px black;
  animation: blink 1s ease-in-out infinite;
}
.solar-panel-3 {
  height: 100%;
  width: 100%;
  position: absolute;
  right: 25%;
  top: 25%;
  background: linear-gradient(to right, #19196c, #2b3b92, #3859ac, #4677c7);
  box-shadow: 1px 1px 2px black;
  animation: blink 1s ease-in-out infinite;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.8vmin;
}

.left-border-connnector {
  animation: blink4 0.4s infinite;
}
.top-border-connnector {
  animation: blink3 0.4s infinite;
}
.y-connector {
  animation: blink5 0.4s infinite;
}

.loss_flow_table td {
  padding:5px 10px;
}
.loss_flow_table th{
padding: 10px;
}

.loss_flow_table td,
.loss_flow_table th {
  font-size: 2vmin;
}

.loss_flow_table>tbody>tr>td>label{
white-space: wrap;
}

@keyframes blink {
  50% {
    border: 2px solid rgb(67, 176, 239);
  }
}

@keyframes blink2 {
  50% {
    background: red;
  }
}

@keyframes blink3 {
  50% {
    border-top: 7px dashed black;
  }
}
@keyframes blink4 {
  50% {
    border-left: 7px dashed black;
  }
}

@keyframes blink5 {
  50% {
    color: black;
  }
}

@media screen and (max-width: 1300px) {
  .loss-flow-container {
    flex-direction: column;
    gap: 2rem;
    height: 100% !important;
  }
  .loss-flow-container > :first-child {
    width: 100%;
    margin: auto;
    /* height: 75% !important; */
  }
  .loss-flow-container > :last-child {
    width: 100%;
    /* height: 75% !important; */
  }
}


`, "",{"version":3,"sources":["webpack://./src/modules/diagonisticModel/LossFlow.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,wBAAmB;EAAnB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;;;AAGrB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB,uBAAuB;AACvB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,YAAY;;AAEd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;;EAEX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb;gBACc;EACd,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb;iBACe;EACf,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,cAAc;EACd,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,0EAA0E;AAC5E;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yEAAyE;EACzE,6BAA6B;EAC7B,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,yEAAyE;EACzE,6BAA6B;EAC7B,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,yEAAyE;EACzE,6BAA6B;EAC7B,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;AACA;AACA,aAAa;AACb;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;AACA,iBAAiB;AACjB;;AAEA;EACE;IACE,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,YAAY;IACZ,4BAA4B;EAC9B;EACA;IACE,WAAW;IACX,4BAA4B;EAC9B;AACF","sourcesContent":["/* #####  Loss Flow Diagram  ##### */\n\n.loss-flow-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: row;\n  /* height: calc(100vh - 60px); */\n  padding: 1rem 1.5rem;\n  width: 100%;\n  height: auto;\n  /* overflow: auto; */\n  /* height: inherit; */\n}\n\n.loss-flow-container > :first-child {\n  width: 64%;\n  display: flex;\n  flex-direction: column;\n  height: fit-content;\n  justify-content: center;\n  align-items: center;\n\n\n}\n\n.loss-flow-container > :last-child {\n  padding:0 1vmin;\n  width: 34%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\nborder: 3px solid black;\n}\n\n.animate-block-1 {\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 1rem;\n  gap: 2rem;\n  width: 860px;\n\n}\n\n.animate-block-1 > div {\n  position: relative;\n  height: 7rem;\n  width: 7rem;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.animate-block-1 > div > img {\n  height: 6rem;\n  width: 6rem;\n}\n\n.direction-arrow {\n  font-weight: 900;\n  font-size: 3rem;\n}\n\n.animate-block-1 > div > span {\n  text-align: center;\n  font-size: 1.2rem;\n}\n\n.transformer > img {\n  position: absolute;\n  bottom: 0;\n  height: 9rem !important;\n  width: 9rem !important;\n}\n\n.transformer > span {\n  position: absolute;\n  bottom: 0;\n}\n\n.inverter > :nth-child(3) {\n  position: absolute;\n  height: 3rem;\n  width: 0.5rem;\n  /* bottom: -45%;\n    left: 35%; */\n  bottom: -3.5rem;\n  left: 2.5rem;\n  background-color: red;\n  /* border: 2px solid red; */\n  animation: blink2 0.5s infinite;\n}\n\n.inverter > :nth-child(3) > div {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  height: 0.5rem;\n  width: 15rem;\n  background-color: red;\n  animation: blink2 0.5s infinite;\n}\n\n.inverter > :nth-child(3) > div > div {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 3rem;\n  width: 0.5rem;\n  background-color: red;\n  animation: blink2 0.5s infinite;\n}\n\n.inverter > :last-child {\n  position: absolute;\n  height: 3rem;\n  width: 0.5rem;\n  /* bottom: -45%;\n    right: 35%; */\n  bottom: -3.5rem;\n  right: 2rem;\n  background-color: blue;\n  /* border: 2px solid red; */\n}\n\n.inverter > :last-child > div {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 0.5rem;\n  width: 10rem;\n  background-color: blue;\n}\n\n.inverter > :last-child > div > div {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  height: 3rem;\n  width: 0.5rem;\n  background-color: blue;\n}\n\n.inverter > :nth-child(3) > div > div > div {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 3vmin;\n  position: absolute;\n  top: 100%;\n  right: -12rem;\n  width: 24rem;\n  height: 5rem;\n  color: white;\n  background: linear-gradient(to right, rgb(124, 208, 93),rgb(124, 208, 93));\n}\n\n.animate-block-2 {\n  /* border: 2px solid red; */\n  /* width: 130vh; */\n  width: 860px;\n  margin: 0 auto;\n  padding: 0.5rem 1rem;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 2.5rem;\n  padding-right: 5rem;\n}\n.animate-block-2 > :first-child {\n  position: absolute;\n  top: -5rem;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.solar-box-1 {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 2.5rem;\n}\n.solar-box-2 {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 2.5rem;\n}\n.solar-box-1 > div,\n.solar-box-2 > div {\n  position: relative;\n  height: 5rem;\n  width: 7rem;\n}\n.solar-panel-1 {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  background: linear-gradient(to right, #19196c, #2b3b92, #3859ac, #4677c7);\n  box-shadow: 1px 1px 2px black;\n  animation: blink 1s ease-in-out infinite;\n}\n.solar-panel-2 {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  right: 12%;\n  top: 12%;\n  background: linear-gradient(to right, #19196c, #2b3b92, #3859ac, #4677c7);\n  box-shadow: 1px 1px 2px black;\n  animation: blink 1s ease-in-out infinite;\n}\n.solar-panel-3 {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  right: 25%;\n  top: 25%;\n  background: linear-gradient(to right, #19196c, #2b3b92, #3859ac, #4677c7);\n  box-shadow: 1px 1px 2px black;\n  animation: blink 1s ease-in-out infinite;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 1.8vmin;\n}\n\n.left-border-connnector {\n  animation: blink4 0.4s infinite;\n}\n.top-border-connnector {\n  animation: blink3 0.4s infinite;\n}\n.y-connector {\n  animation: blink5 0.4s infinite;\n}\n\n.loss_flow_table td {\n  padding:5px 10px;\n}\n.loss_flow_table th{\npadding: 10px;\n}\n\n.loss_flow_table td,\n.loss_flow_table th {\n  font-size: 2vmin;\n}\n\n.loss_flow_table>tbody>tr>td>label{\nwhite-space: wrap;\n}\n\n@keyframes blink {\n  50% {\n    border: 2px solid rgb(67, 176, 239);\n  }\n}\n\n@keyframes blink2 {\n  50% {\n    background: red;\n  }\n}\n\n@keyframes blink3 {\n  50% {\n    border-top: 7px dashed black;\n  }\n}\n@keyframes blink4 {\n  50% {\n    border-left: 7px dashed black;\n  }\n}\n\n@keyframes blink5 {\n  50% {\n    color: black;\n  }\n}\n\n@media screen and (max-width: 1300px) {\n  .loss-flow-container {\n    flex-direction: column;\n    gap: 2rem;\n    height: 100% !important;\n  }\n  .loss-flow-container > :first-child {\n    width: 100%;\n    margin: auto;\n    /* height: 75% !important; */\n  }\n  .loss-flow-container > :last-child {\n    width: 100%;\n    /* height: 75% !important; */\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
